import {
  IsArray,
  IsNotEmpty,
  IsString,
  ValidateNested,
  IsUUID,
} from 'class-validator';

import { NotificationMessagesDto } from './notification-messages.dto';
import { EmployeeTimezoneExceptionDto } from './employee-timezone-exception.dto';

export class UpdateEmployeeTimezoneDto {
  @IsArray()
  @IsNotEmpty()
  @ValidateNested({ each: true })
  employees: EmployeeTimezoneExceptionDto[];

  @IsString()
  @IsNotEmpty()
  @IsUUID()
  timezoneId: string;

  @IsString()
  @IsNotEmpty()
  timezoneName: string;

  notificationMessages: NotificationMessagesDto;
}
